import type { RpmResponse } from '@on3/api';
import { SwapIcon } from '@public/components/Icons/SwapIcon';
import { On3Avatar } from '@public/components/Image/On3Avatar';
import { ConditionalLink } from '@public/components/UI/StarRating/StarRating';
import { Text } from '@public/components/UI/Typography/Text';
import clsx from 'clsx';

import styles from './PlayerRpmItem.module.scss';

interface IPlayerRpmItemProps extends RpmResponse {
  year?: number | null;
  sport?: string | null;
}

const borderColor = (primaryColor?: string | null) => ({
  border: `solid 4px ${primaryColor || '#000000'}`,
});

export const PlayerRpmItem = ({
  organization,
  percent,
  year,
  sport,
  committed,
  committedDate,
  flippedFromOrganization,
}: IPlayerRpmItemProps) => {
  return (
    <div
      className={clsx(styles.itemBlock, {
        [styles.isFlipped]: flippedFromOrganization,
      })}
      style={committed ? borderColor(organization?.primaryColor) : undefined}
    >
      <div className={styles.logosContainer}>
        {flippedFromOrganization && (
          <>
            <On3Avatar
              className={styles.flippedTeamLogo}
              domain={flippedFromOrganization?.asset?.domain}
              height={40}
              source={flippedFromOrganization?.asset?.source}
              teamAvatar
              type={flippedFromOrganization?.asset?.type}
              width={40}
            />
            <SwapIcon className={styles.swapIcon} />
          </>
        )}
        <On3Avatar
          className={clsx(styles.teamLogo, {
            [styles.isFlipped]: flippedFromOrganization,
          })}
          domain={organization?.asset?.domain}
          height={50}
          source={organization?.asset?.source}
          teamAvatar
          type={organization?.asset?.type}
          width={50}
        />
      </div>

      <ConditionalLink
        className={styles.team}
        condition={!!(organization?.slug && sport && year)}
        href={`/college/${organization?.slug}/${sport}/${year}/industry-comparison-commits/`}
        underline="none"
        variant="h5"
      >
        {organization?.name}
      </ConditionalLink>

      <Text
        className={clsx(styles.percent, {
          [styles.isFlipped]: flippedFromOrganization,
        })}
        variant="subtitle1"
      >
        {!percent && 'N/A'}
        {percent && `${percent >= 1 ? percent?.toFixed(1) : '<1'}%`}
      </Text>
    </div>
  );
};
